import React from 'react';
import BaseSelector, { SelectProps } from '@/components/selectors/BaseSelector';
import { ValidationRule } from '@core/utils/validation.ts';
import { useFormField } from '@core/hooks/useFormField';

export interface FormSelectProps extends Omit<SelectProps, 'error' | 'helperText' | 'onBlur'> {
    name: string;
    rules?: ValidationRule[];
    helperText?: string;
}

export const FormSelect: React.FC<FormSelectProps> = ({
    name,
    rules = [],
    value,
    onChange,
    helperText: staticHelperText,
    ...selectProps
}) => {
    const { error, showError, handleBlur, handleChange } = useFormField({
        name,
        label: selectProps.label,
        value,
        rules,
        onChange
    });

    return (
        <BaseSelector
            {...selectProps}
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            error={showError}
            helperText={showError ? error : staticHelperText}
            data-form-field={name}
        />
    );
};

FormSelect.displayName = 'FormSelect';

export default FormSelect;
